// Traduções do Gerar viagem de retorno — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'transporte.retorno.titulo': 'Gerar viagem de retorno',
    'transporte.retorno.remessa': 'Remessa',
    'transporte.retorno.maquinas': 'Máquinas',
    'transporte.retorno.origem': 'Origem do retorno',
    'transporte.retorno.conjunto': 'Conjunto da prancha',
    'transporte.retorno.buscarConjunto': 'Buscar motorista ou placa…',
    'transporte.retorno.prevista': 'Data prevista',
    'transporte.retorno.destino': 'Local de destino',
    'transporte.retorno.buscarDestino': 'Buscar local…',
    'transporte.retorno.aviso': 'A viagem nasce com o tipo Retorno, as máquinas da remessa e a origem no destino dela. O HUB pede ao Fiscal a Nota de Retorno Real e o MDF-e da prancha.',
    'transporte.retorno.confirmar': 'Gerar retorno',
    'transporte.retorno.erroConjunto': 'Escolha o conjunto da prancha.',
    'transporte.retorno.erroDatas': 'Informe a data prevista.',
    'transporte.retorno.erroDestino': 'Escolha o Local de destino.',
    'transporte.retorno.feito': 'Viagem de retorno {{registro}} criada. A Nota de Retorno Real e o MDF-e da prancha foram pedidos ao Fiscal.',
    'transporte.retorno.feitoSemEmail': 'Viagem de retorno {{registro}} criada, mas o e-mail ao Fiscal não saiu. {{motivo}}',
  },
  en: {
    'transporte.retorno.titulo': 'Create return trip',
    'transporte.retorno.remessa': 'Shipment',
    'transporte.retorno.maquinas': 'Machines',
    'transporte.retorno.origem': 'Return origin',
    'transporte.retorno.conjunto': 'Lowboy set',
    'transporte.retorno.buscarConjunto': 'Search driver or plate…',
    'transporte.retorno.prevista': 'Expected date',
    'transporte.retorno.destino': 'Destination location',
    'transporte.retorno.buscarDestino': 'Search location…',
    'transporte.retorno.aviso': 'The trip is created with the Return type, the shipment machines and its destination as origin. The HUB asks Tax for the Real Return Invoice and the lowboy MDF-e.',
    'transporte.retorno.confirmar': 'Create return',
    'transporte.retorno.erroConjunto': 'Choose the lowboy set.',
    'transporte.retorno.erroDatas': 'Fill in the expected date.',
    'transporte.retorno.erroDestino': 'Choose the destination location.',
    'transporte.retorno.feito': 'Return trip {{registro}} created. The Real Return Invoice and the lowboy MDF-e were requested from Tax.',
    'transporte.retorno.feitoSemEmail': 'Return trip {{registro}} created, but the e-mail to Tax was not sent. {{motivo}}',
  },
  es: {
    'transporte.retorno.titulo': 'Generar viaje de retorno',
    'transporte.retorno.remessa': 'Remesa',
    'transporte.retorno.maquinas': 'Máquinas',
    'transporte.retorno.origem': 'Origen del retorno',
    'transporte.retorno.conjunto': 'Conjunto de cama baja',
    'transporte.retorno.buscarConjunto': 'Buscar conductor o placa…',
    'transporte.retorno.prevista': 'Fecha prevista',
    'transporte.retorno.destino': 'Lugar de destino',
    'transporte.retorno.buscarDestino': 'Buscar lugar…',
    'transporte.retorno.aviso': 'El viaje nace con el tipo Retorno, las máquinas de la remesa y el origen en su destino. El HUB pide al Fiscal la Nota de Retorno Real y el MDF-e de la cama baja.',
    'transporte.retorno.confirmar': 'Generar retorno',
    'transporte.retorno.erroConjunto': 'Elija el conjunto de cama baja.',
    'transporte.retorno.erroDatas': 'Informe la fecha prevista.',
    'transporte.retorno.erroDestino': 'Elija el lugar de destino.',
    'transporte.retorno.feito': 'Viaje de retorno {{registro}} creado. La Nota de Retorno Real y el MDF-e de la cama baja fueron pedidos al Fiscal.',
    'transporte.retorno.feitoSemEmail': 'Viaje de retorno {{registro}} creado, pero el correo al Fiscal no salió. {{motivo}}',
  },
}
